'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _isomorphicFetch = require('isomorphic-fetch');

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _lesson = require('redux/modules/lesson');

var lessonActions = _interopRequireWildcard(_lesson);

var _reactRedux = require('react-redux');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isLoaded = lessonActions.isLoaded,
    loadLessonsByName = lessonActions.loadLessonsByName;
var LessonSelection = (_dec = (0, _reactRedux.connect)(function (state) {
	return {
		lessons: state.lesson.lessons_by_name
	};
}, (0, _extends3.default)({}, lessonActions)), _dec(_class = function (_Component) {
	(0, _inherits3.default)(LessonSelection, _Component);

	// displayName: 'GithubUsers'

	function LessonSelection(props) {
		(0, _classCallCheck3.default)(this, LessonSelection);

		var _this = (0, _possibleConstructorReturn3.default)(this, (LessonSelection.__proto__ || (0, _getPrototypeOf2.default)(LessonSelection)).call(this, props));

		_this.propTypes = {
			label: _propTypes2.default.string,
			lessons: _propTypes2.default.object
		};

		_this.state = {
			backspaceRemoves: true,
			multi: false,
			creatable: false
		};
		return _this;
	}

	(0, _createClass3.default)(LessonSelection, [{
		key: 'onChange',
		value: function onChange(value) {
			console.log(value);
			this.setState({
				value: value
			});

			this.props.onChange(value);
		}
	}, {
		key: 'switchToMulti',
		value: function switchToMulti() {
			this.setState({
				multi: true,
				value: [this.state.value]
			});
		}
	}, {
		key: 'switchToSingle',
		value: function switchToSingle() {
			this.setState({
				multi: false,
				value: this.state.value ? this.state.value[0] : null
			});
		}
	}, {
		key: 'getUsers',
		value: function getUsers(input) {

			if (!input) {
				return _promise2.default.resolve({ options: [] });
			}

			// {"limit":10, "where":{"name":{"like":"%Present%","options":"i"}}} //for searching
			return (0, _isomorphicFetch2.default)('https://api.github.com/search/users?q=' + input)
			// return fetch(`https://api.github.com/search/users?q=${encodeURI('{"limit":10, "where":{"name":{"like":"%Present%","options":"i"}}}')}`)
			.then(function (response) {
				return response.json();
			}).then(function (json) {
				console.log(json.items);
				return { options: json.items };
			});
		}
	}, {
		key: 'gotoUser',
		value: function gotoUser(value, event) {
			window.open(value.html_url);
		}
	}, {
		key: 'toggleBackspaceRemoves',
		value: function toggleBackspaceRemoves() {
			this.setState({
				backspaceRemoves: !this.state.backspaceRemoves
			});
		}
	}, {
		key: 'toggleCreatable',
		value: function toggleCreatable() {
			this.setState({
				creatable: !this.state.creatable
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var AsyncComponent = this.state.creatable ? _reactSelect2.default.AsyncCreatable : _reactSelect2.default.Async;

			return _react2.default.createElement(
				'div',
				{ className: 'section' },
				_react2.default.createElement(AsyncComponent, {
					multi: this.state.multi,
					value: this.state.value,
					onChange: this.onChange.bind(this),
					onValueClick: function onValueClick(data) {
						// this.gotoUser(data)
					},
					valueKey: 'id',
					labelKey: 'name',
					loadOptions: function loadOptions(input) {
						console.log(input);
						if (!input) {
							return _promise2.default.resolve({ options: [] });
						}
						return _this2.props.loadLessonsByName(input).then(function (response) {
							console.log((0, _stringify2.default)(response));

							// return {
							// 	options: [
							// 		{
							// 			"id": 12,
							// 			"login": "haha"
							// 		}
							// 	]
							// }
							return { options: response };
						});
						// .then((json) => {
						// 	console.log(json.items);
						// 	return { options: json.items };
						// });
						// this.getUsers(input);
					},
					backspaceRemoves: this.state.backspaceRemoves })
			);
		}
	}]);
	return LessonSelection;
}(_react.Component)) || _class);

// module.exports = LessonSelection;

exports.default = LessonSelection;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Content/LessonSelection.js
// module id = 1498
// module chunks = 0